import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import AddPayment from "./add_payment.js";
import Transactions from "./transactions.js";
import PaymentsArchive from "./paymentsArchive.js";
import PaymentsReport from "./payment_report.js";
import AddNewTransactions from "./addNewTransactions.js";
import Loading from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const Payments = (props) => {
  const [showAddPayments, setShowAddPayments] = useState(false);
  const [showTransactions, setShowTransactions] = useState(false);
  const [showTransactionsNa, setShowTransactionsNa] = useState(false);
  const [showPaymentsArchive, setShowPaymentsArchive] = useState(false);
  const [showAddNewTransactions, setShowAddNewTransactions] = useState(false);
  const [payments, setPayments] = useState([]);
  const [payments2, setPayments2] = useState([]);
  const [paymentsClear, setPaymentsClear] = useState([]);
  const [search, setSearch] = useState("");
  const [searchMail, setSearchMail] = useState("");
  const [searchID, setSearchID] = useState("");
  const [showPaymentReport, setShowPaymentsReport] = useState(false);
  const [paymentReportValue, setPaymentsReportValue] = useState("");
  const [archivized, setArchivized] = useState(false);
  const [filter, setFilter] = useState("all");
  const [sort, setSort] = useState("");
  const [arrToArchive, setArrToArchive] = useState([]);
  const [archToAdd, setArchToAdd] = useState([]);
  const [payToDelete, setPayToDelete] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timer, setTimer] = useState(null);
  const [expandMobileFilters, setExpandMobileFilters] = useState(false);

  const handleExpandMobileChange = () => {
    setExpandMobileFilters(!expandMobileFilters);
  };

  const fetchPayments = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data = getAllowedClients(data.filter((el) => !el.archive_date));
        var arr = [];

        setPayments(
          data.sort(
            (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
          )
        );
        setPayments2(
          data.sort(
            (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
          )
        );
        setPaymentsClear(
          data.sort(
            (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
          )
        );
        handleFilterChangeRefresh(data);
        handleSearchChangeRefresh();
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.clientId === +el));
      });
      return arr;
    }
  };

  const getData = () => {
    setLoading(true);
    fetchPayments();
  };

  useEffect(() => {
    getData();
  }, []);

  const clearSearch = (e) => {
    setPayments(
      paymentsClear.sort(
        (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
      )
    );
    setPayments2(
      paymentsClear.sort(
        (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
      )
    );
    setFilter("all");
    setSort("f1a");
    setArchivized(false);
    setSearch("");
    setSearchID("");
    setSearchMail("");
  };

  const handleShowAddPayment = (e) => {
    setShowAddPayments(!showAddPayments);
    setShowTransactions(false);
    setShowPaymentsArchive(false);
    setShowAddNewTransactions(false);
    setShowPaymentsReport(false);
    setShowTransactionsNa(false);
    if (!showAddPayments === false) {
      getData();
    }
  };

  const handleShowPayment = (e) => {
    setShowAddPayments(false);
    setShowTransactions(false);
    setShowPaymentsArchive(false);
    setShowAddNewTransactions(false);
    setShowPaymentsReport(false);
    setShowTransactionsNa(false);
  };

  const handleShowTransactions = (e) => {
    setShowTransactions(!showTransactions);
    setShowAddPayments(false);
    setShowPaymentsArchive(false);
    setShowAddNewTransactions(false);
    setShowPaymentsReport(false);
    setShowTransactionsNa(false);
  };

  const handleShowTransactionsNa = (e) => {
    setShowTransactionsNa(!showTransactionsNa);
    setShowAddPayments(false);
    setShowPaymentsArchive(false);
    setShowAddNewTransactions(false);
    setShowPaymentsReport(false);
    setShowTransactions(false);
  };

  const handleShowPaymentsArchive = (e) => {
    setShowTransactions(false);
    setShowAddPayments(false);
    setShowAddNewTransactions(false);
    setShowPaymentsReport(false);
    setShowTransactionsNa(false);
    setShowPaymentsArchive(!showPaymentsArchive);
  };

  const handleShowAddNewTransactions = (e) => {
    setShowTransactions(false);
    setShowAddPayments(false);
    setShowPaymentsArchive(false);
    setShowPaymentsReport(false);
    setShowTransactionsNa(false);
    setShowAddNewTransactions(!showAddNewTransactions);
  };

  const handleShowPaymentReport = (e) => {
    setShowTransactions(false);
    setShowAddPayments(false);
    setShowPaymentsArchive(false);
    setShowAddNewTransactions(false);
    setShowTransactionsNa(false);
    setShowPaymentsReport(!showPaymentReport);
    if (!showPaymentReport === false) {
      getData();
    }
  };

  const handleSearchChange = (e) => {
    setSearchID("");
    setSearchMail("");
    setSearch(e.target.value);
    if (e.target.value === "") {
      setPayments(payments2);
    } else {
      setPayments(
        payments2.filter((el) =>
          el.name
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSearchIdChange = (e) => {
    setSearch("");
    setSearchMail("");
    setSearchID(e.target.value);
    if (e.target.value === "") {
      setPayments(payments2);
    } else {
      setPayments(
        payments2.filter(
          (el) =>
            el.identifier.toString().toLowerCase() ===
            e.target.value.toString().toLowerCase()
        )
      );
    }
  };

  const handleSearchMailChange = (e) => {
    setSearch("");
    setSearchID("");
    setSearchMail(e.target.value);
    if (e.target.value === "") {
      setPayments(payments2);
    } else {
      setPayments(
        payments2.filter((el) =>
          el.email
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const handleSearchChangeRefresh = (e) => {
    if (searchMail.length > 0) {
      if (searchMail === "") {
        setPayments(payments2);
      } else {
        setPayments(
          payments2.filter((el) =>
            el.email
              .toString()
              .toLowerCase()
              .includes(searchMail.toString().toLowerCase())
          )
        );
      }
    }

    if (searchID.length > 0) {
      if (searchID === "") {
        setPayments(payments2);
      } else {
        setPayments(
          payments2.filter(
            (el) =>
              el.identifier.toString().toLowerCase() ===
              searchID.toString().toLowerCase()
          )
        );
      }
    }

    if (search.length > 0) {
      if (search === "") {
        setPayments(payments2);
      } else {
        setPayments(
          payments2.filter((el) =>
            el.name
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase())
          )
        );
      }
    }
  };

  const handleRowClick = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setPaymentsReportValue(value);
    handleShowPaymentReport();
  };

  const choosePayment = (e) => {
    var exist = arrToArchive.filter((el) => el === e.target.value).length > 0;
    if (exist) {
      var deleteArr = arrToArchive.filter((el) => el !== e.target.value);
      setArrToArchive(deleteArr);
    } else {
      var addArr = arrToArchive;
      addArr.push(e.target.value);
      setArrToArchive(addArr);
    }
  };

  const paymentsData = (
    <>
      <table className="clients_table">
        <tr key={0}>
          {archivized ? <th>Wybierz</th> : ""}
          <th>ID</th>
          <th>Imię i nazwisko</th>
          <th>Adres e-mail</th>
          <th>Numer telefonu</th>
          <th>Data pierwszej płatności</th>
          <th>Do rozliczenia</th>
          <th>Ilość rat</th>
          <th>Kwota wpłacona</th>
          <th>Ilość wpłaconych rat</th>
          <th>Ilość oczekiwanych rat</th>
          <th>Data ostatniej płatności</th>
          <th>Ilość dni po terminie</th>
          <th>Po terminie?</th>
        </tr>
        {payments.map((el) => (
          <>
            <tr
              id={
                el.to_archive === "TAK"
                  ? "archiveRow"
                  : +el.delay_time > 10
                  ? "overdatedRow"
                  : +el.delay_time <= 10 && el.to_archive !== "TAK"
                  ? "yellowRow"
                  : el.pay_sum === undefined
                  ? "newRow"
                  : ""
              }
              key={el.id}
            >
              {archivized ? (
                <>
                  <td>
                    <input
                      id="checkCal3"
                      type="checkbox"
                      value={el.identifier}
                      onChange={choosePayment}
                    />
                  </td>
                </>
              ) : (
                ""
              )}
              <td>{el.identifier}</td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.name}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.email}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.phone}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.first_payment_date}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {(+el.to_settlement).toFixed(2)}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.installment}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {(+el.pay_sum).toFixed(2)}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.pay_count}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.pay_expected_count}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.last_pay_date}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.delay_time}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.is_overdated}
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const paymentsDataMobile = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th style={{ fontSize: "3vw" }}>ID</th>
          <th style={{ fontSize: "3vw" }}>Imię i nazwisko</th>
          <th style={{ fontSize: "3vw" }}>Po terminie?</th>
        </tr>
        {payments.map((el) => (
          <>
            <tr
              id={
                el.to_archive === "TAK"
                  ? "archiveRow"
                  : +el.delay_time > 10
                  ? "overdatedRow"
                  : +el.delay_time <= 10 && el.to_archive !== "TAK"
                  ? "yellowRow"
                  : el.pay_sum === undefined
                  ? "newRow"
                  : ""
              }
              key={el.id}
            >
              <td>{el.identifier}</td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.name}
              </td>
              <td value={el.identifier} onClick={handleRowClick}>
                {el.is_overdated}
              </td>
            </tr>
          </>
        ))}
      </table>
    </>
  );

  const checkArchivized = (e) => {
    setArrToArchive([]);
    setArchivized(e.target.checked);
    if (e.target.checked === true) {
      setPayments(payments.filter((el) => el.to_archive === "TAK"));
    } else {
      setPayments(paymentsClear);
    }
  };

  const handleFilterChange = (e) => {
    setSearchMail("");
    setSearch("");
    setSearchID("");
    setFilter(e.target.value);

    if (e.target.value === "archivized") {
      setArchivized(true);
      setPayments(paymentsClear.filter((el) => el.to_archive === "TAK"));
      setPayments2(paymentsClear.filter((el) => el.to_archive === "TAK"));
    } else if (e.target.value === "in_time") {
      setArchivized(false);
      setPayments(
        paymentsClear.filter(
          (el) => +el.delay_time <= 10 && el.to_archive !== "TAK"
        )
      );
      setPayments2(
        paymentsClear.filter(
          (el) => +el.delay_time <= 10 && el.to_archive !== "TAK"
        )
      );
    } else if (e.target.value === "delayed") {
      setArchivized(false);
      setPayments(paymentsClear.filter((el) => +el.delay_time >= 10));
      setPayments2(paymentsClear.filter((el) => +el.delay_time >= 10));
    } else if (e.target.value === "delayed_10") {
      setArchivized(false);
      setPayments(paymentsClear.filter((el) => +el.delay_time >= 10));
      setPayments2(paymentsClear.filter((el) => +el.delay_time >= 10));
    } else if (e.target.value === "not_connected") {
      setArchivized(false);
      setPayments(paymentsClear.filter((el) => el.clientId === ""));
      setPayments2(paymentsClear.filter((el) => el.clientId === ""));
    } else if (e.target.value === "all") {
      setArchivized(false);
      setPayments(paymentsClear);
      setPayments2(paymentsClear);
    }
  };

  const handleFilterChangeRefresh = (data) => {
    setFilter(filter);

    if (filter === "archivized") {
      setArchivized(true);
      setPayments(data.filter((el) => el.to_archive === "TAK"));
      setPayments2(data.filter((el) => el.to_archive === "TAK"));
    } else if (filter === "in_time") {
      setArchivized(false);
      setPayments(
        data.filter((el) => +el.delay_time <= 10 && el.to_archive !== "TAK")
      );
      setPayments2(
        data.filter((el) => +el.delay_time <= 10 && el.to_archive !== "TAK")
      );
    } else if (filter === "delayed") {
      setArchivized(false);
      setPayments(data.filter((el) => +el.delay_time >= 10));
      setPayments2(data.filter((el) => +el.delay_time >= 10));
    } else if (filter === "delayed_10") {
      setArchivized(false);
      setPayments(data.filter((el) => +el.delay_time >= 10));
      setPayments2(data.filter((el) => +el.delay_time >= 10));
    } else if (filter === "not_connected") {
      setArchivized(false);
      setPayments(data.filter((el) => el.clientId === ""));
      setPayments2(data.filter((el) => el.clientId === ""));
    } else if (filter === "all") {
      setArchivized(false);
      setPayments(data);
      setPayments2(data);
    }
  };

  const handleSortChange = (e) => {
    setSort(e.target.value);
    if (e.target.value === "f1a") {
      setPayments(
        payments.sort(
          (a, b) => parseInt(b.to_settlement) - parseInt(a.to_settlement)
        )
      );
    } else if (e.target.value === "f1b") {
      setPayments(
        payments.sort(
          (a, b) => parseInt(a.to_settlement) - parseInt(b.to_settlement)
        )
      );
    } else if (e.target.value === "f2a") {
      setPayments(
        payments.sort((a, b) => parseInt(b.delay_time) - parseInt(a.delay_time))
      );
    } else if (e.target.value === "f2b") {
      setPayments(
        payments.sort((a, b) => parseInt(a.delay_time) - parseInt(b.delay_time))
      );
    } else if (e.target.value === "f3a") {
      setPayments(
        payments.sort(
          (a, b) =>
            new Date(a.first_payment_date) - new Date(b.first_payment_date)
        )
      );
    } else if (e.target.value === "f3b") {
      setPayments(
        payments.sort(
          (a, b) =>
            new Date(b.first_payment_date) - new Date(a.first_payment_date)
        )
      );
    } else if (e.target.value === "f4a") {
      setPayments(paymentsClear);
    }
  };

  const archivizePayment = async (id, mode) => {
    var toEditData = paymentsClear.filter((el) => el.identifier === id)[0];
    var body = {
      name: toEditData.name,
      identifier: toEditData.identifier,
      email: toEditData.email,
      phone: toEditData.phone,
      first_payment_date: toEditData.first_payment_date,
      company: toEditData.company,
      type: toEditData.type,
      to_settlement: toEditData.to_settlement,
      installment: toEditData.installment,
      pay_sum: toEditData.pay_sum,
      pay_count: toEditData.pay_count,
      pay_expected_count: toEditData.pay_expected_count,
      last_pay_date: toEditData.last_pay_date,
      is_overdated: toEditData.is_overdated,
      to_archive: toEditData.to_archive,
      archive_date: new Date(),
      clientId: toEditData.clientId,
      bank_acc: toEditData.bank_acc,
      delay_time: toEditData.delay_time,
      id: id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertPaymentArchive", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    //deletePayment(toEditData.id, "arr");
    if (mode !== "1") {
      MySwal.fire({
        icon: "success",
        title: "Zarchiwizowano",
        text: "płatność",
      }).then((result) => {
        getData();
      });
    }
  };

  const deletePayment = async (id, mode) => {
    var body = {
      id: id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deletePayment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    if (mode === "arr") {
    } else {
      MySwal.fire({
        icon: "success",
        title: "Usunięto",
        text: "płatność",
      }).then((result) => {
        getData();
      });
    }
  };

  const archivizeMany = async (e) => {
    setArchToAdd([]);
    setPayToDelete([]);
    if (arrToArchive.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Zaznacz",
        text: "płatności, aby zarchiwizować",
      });
    } else {
      arrToArchive.map((el) => {
        archivizePayment(el, "1");
      });

      MySwal.fire({
        icon: "success",
        title: "Zarchiwizowano",
        text: "płatności",
      });
      getData();
    }
  };

  const checkPayments = async () => {
    var body = {};
    await fetch("https://apidevkppp.ftpeople.pl/getTransactionsAssigned", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        checkPaymentsA(data);
      })
      .catch((error) => {});
  };

  const checkPaymentsA = async (transactions) => {
    setLoading(true);

    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getPayments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        data.map(async (el) => {
          var transactionsForPayment = transactions.filter(
            (tr) => tr.payId === el.identifier
          );
          transactionsForPayment.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });
          var pay_sum = 0;
          for (var i = 0; i < transactionsForPayment.length; i += 1) {
            pay_sum =
              parseFloat(transactionsForPayment[i].bill.replaceAll(",", ".")) +
              pay_sum;
          }

          var archive =
            parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE";
          var bankAcc = el.bank_acc;
          if (transactionsForPayment.length > 0) {
            if (
              !transactionsForPayment[0].title.includes("Wpłata w UP") &&
              !transactionsForPayment[0].client.includes("CINKCIARZ")
            ) {
              bankAcc = transactionsForPayment[0].bank_acc;
            }
          }

          var body2 = {
            identifier: el.identifier,
            pay_sum: pay_sum,
            bank_acc: bankAcc,
            pay_count: transactionsForPayment.length,
            pay_expected_count: checkExpectedTransactionsCount(
              el.first_payment_date,
              el.installment
            ),
            last_pay_date:
              transactionsForPayment.length > 0
                ? transactionsForPayment[0].date
                : "",
            is_overdated:
              checkExpectedTransactionsCount(
                el.first_payment_date,
                el.installment
              ) > transactionsForPayment.length
                ? "TAK"
                : "NIE",
            to_archive:
              parseInt(el.to_settlement) === parseInt(pay_sum) ? "TAK" : "NIE",
            delay_time:
              archive === "TAK"
                ? 0
                : getDelayTime(
                    el.first_payment_date,
                    transactionsForPayment.length,
                    checkExpectedTransactionsCount(
                      el.first_payment_date,
                      el.installment
                    )
                  ),
          };

          await fetch("https://apidevkppp.ftpeople.pl/editPaymentCheck", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});
        });
      })
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Przeliczono",
      text: "rozliczenia",
    }).then((result) => {
      props.refreshData();
    });
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const getDelayTime = (dateOfStartPayment, pay_sum, expected_pay_count) => {
    var startDate = new Date(dateOfStartPayment);
    var now = new Date();
    var lastPaymentDateForDelay = new Date(
      startDate.setMonth(startDate.getMonth() + pay_sum)
    );
    var delay_days = days(now, lastPaymentDateForDelay);
    return delay_days < 0 ? 0 : delay_days;
  };

  const checkExpectedTransactionsCount = (
    dateOfStartPayment,
    installmentCount
  ) => {
    var now = new Date();
    var startDate = new Date(dateOfStartPayment);
    var months = (now.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += now.getMonth();
    return months <= 0
      ? 0
      : months > installmentCount
      ? installmentCount
      : months;
  };

  const desktopFilters = (
    <>
      <div className="closeButtonBoxNotePopUp">
        <div className="searchBoxP">
          <label>Wyszukaj po imieniu i nazwisku</label>
          <input
            type="text"
            id="name"
            name="name"
            value={search}
            onChange={handleSearchChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Wyszukaj po ID</label>
          <input
            type="text"
            id="name"
            name="name"
            value={searchID}
            onChange={handleSearchIdChange}
          />
        </div>
        <div className="searchBoxP">
          <label>Wyszukaj po adresie e-mail</label>
          <input
            type="text"
            id="name"
            name="name"
            value={searchMail}
            onChange={handleSearchMailChange}
          />
        </div>
        <div className="filterBoxP">
          <label>Filtrowanie</label>
          <select
            type="text"
            id="filterP"
            name="court"
            value={filter}
            onChange={handleFilterChange}
          >
            <option key={0} value="all">
              Wszystkie
            </option>
            <option key={1} value="archivized">
              Do archiwizacji
            </option>
            <option key={2} value="delayed">
              Opóźnione
            </option>
            <option key={3} value="in_time">
              Płacone w terminie
            </option>
            <option key={4} value="not_connected">
              Niepowiązane
            </option>
          </select>
        </div>
        <div className="filterBoxP">
          <label>Sortowanie</label>
          <select
            type="text"
            id="filterP"
            name="court"
            value={sort}
            onChange={handleSortChange}
          >
            <option key={0} value="f1a">
              Kwota do rozliczenia - od największej
            </option>
            <option key={1} value="f1b">
              Kwota do rozliczenia - od najmniejszej
            </option>
            <option key={2} value="f2a">
              Ilość dni po terminie - od największej
            </option>
            <option key={3} value="f2b">
              Ilość dni po terminie - od najmniejszej
            </option>
            <option key={4} value="f3a">
              Data pierwszej płatności - od najstarszej
            </option>
            <option key={5} value="f3b">
              Data pierwszej płatności - od najmłodszej
            </option>
          </select>
        </div>
        {archivized && props.user.role === "admin" ? (
          <button
            id="archiveButtonP"
            className="paymentMenuButton"
            onClick={archivizeMany}
          >
            Archiwizuj zaznaczone
          </button>
        ) : (
          ""
        )}
      </div>
      <div id="closeButtonTR" className="closeButtonBoxNotePopUp">
        <button className="paymentMenuButton" onClick={clearSearch}>
          wyczyść
        </button>
      </div>
    </>
  );

  const mobileFilters = (
    <>
      <div
        style={
          expandMobileFilters
            ? { display: "flex", width: "100%", padding: "3vh 0" }
            : { display: "flex", width: "100%", padding: "3vh 0" }
        }
      >
        <div style={{ width: "100%" }}>
          <button
            className="calendarUserButton"
            style={{ width: "100%", justifyContent: "center" }}
            value={props.user.name}
            onClick={handleExpandMobileChange}
          >
            {!expandMobileFilters ? "ROZWIŃ FILTRY" : "ZWIŃ FILTRY"}
          </button>
        </div>
      </div>
      {expandMobileFilters ? (
        <>
          {" "}
          <div className="closeButtonBoxNotePopUp" style={{ flexWrap: "wrap" }}>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Wyszukaj po imieniu i nazwisku</label>
              <input
                type="text"
                id="name"
                name="name"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Wyszukaj po ID</label>
              <input
                type="text"
                id="name"
                name="name"
                value={searchID}
                onChange={handleSearchIdChange}
              />
            </div>
            <div
              className="searchBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Wyszukaj po adresie e-mail</label>
              <input
                type="text"
                id="name"
                name="name"
                value={searchMail}
                onChange={handleSearchMailChange}
              />
            </div>
            <div
              className="filterBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Filtrowanie</label>
              <select
                type="text"
                id="filterP"
                name="court"
                value={filter}
                onChange={handleFilterChange}
              >
                <option key={0} value="all">
                  Wszystkie
                </option>
                <option key={1} value="archivized">
                  Do archiwizacji
                </option>
                <option key={2} value="delayed">
                  Opóźnione
                </option>
                <option key={3} value="in_time">
                  Płacone w terminie
                </option>
                <option key={4} value="not_connected">
                  Niepowiązane
                </option>
              </select>
            </div>
            <div
              className="filterBoxP"
              style={{ width: "100%", marginBottom: "1vh" }}
            >
              <label>Sortowanie</label>
              <select
                type="text"
                id="filterP"
                name="court"
                value={sort}
                onChange={handleSortChange}
              >
                <option key={0} value="f1a">
                  Kwota do rozliczenia - od największej
                </option>
                <option key={1} value="f1b">
                  Kwota do rozliczenia - od najmniejszej
                </option>
                <option key={2} value="f2a">
                  Ilość dni po terminie - od największej
                </option>
                <option key={3} value="f2b">
                  Ilość dni po terminie - od najmniejszej
                </option>
                <option key={4} value="f3a">
                  Data pierwszej płatności - od najstarszej
                </option>
                <option key={5} value="f3b">
                  Data pierwszej płatności - od najmłodszej
                </option>
              </select>
            </div>
            {archivized && props.user.role === "admin" ? (
              <button
                id="archiveButtonP"
                className="paymentMenuButton"
                onClick={archivizeMany}
              >
                Archiwizuj zaznaczone
              </button>
            ) : (
              ""
            )}
          </div>
          <div
            id="closeButtonTR"
            className="closeButtonBoxNotePopUp"
            style={{ width: "100%", marginTop: "2vh" }}
          >
            <button className="paymentMenuButton" onClick={clearSearch}>
              wyczyść
            </button>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <div className="mainContainerPayments">
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="paymentMenuContainer">
          <button className="paymentMenuButton" onClick={handleShowAddPayment}>
            Dodaj płatność
          </button>
          <button className="paymentMenuButton" onClick={handleShowPayment}>
            Lista płatności
          </button>
          <button
            className="paymentMenuButton"
            onClick={handleShowPaymentsArchive}
          >
            Archiwum płatności
          </button>
          {props.user.role === "admin" ? (
            <>
              <button
                className="paymentMenuButton"
                onClick={handleShowTransactionsNa}
              >
                Lista transakcji
              </button>
            </>
          ) : (
            ""
          )}
          {props.user.role === "admin" ? (
            <>
              <button
                className="paymentMenuButton"
                onClick={handleShowTransactions}
              >
                Archiwum transakcji
              </button>
            </>
          ) : (
            ""
          )}
          {props.user.role === "admin" ? (
            <>
              <button
                className="paymentMenuButton"
                onClick={handleShowAddNewTransactions}
              >
                Dodaj plik CSV
              </button>
            </>
          ) : (
            ""
          )}
          {false ? (
            <>
              <button className="paymentMenuButton" onClick={checkPayments}>
                Przelicz rozliczenia
              </button>{" "}
            </>
          ) : (
            ""
          )}
        </div>

        {showAddPayments ? (
          <>
            <AddPayment
              close={handleShowAddPayment}
              paymentsSheetData={props.paymentsSheetData}
              paymentsData={paymentsClear}
              refreshData={props.refreshData}
              modeAdd={"main"}
              transactionsSheetData={props.transactionsSheetData}
              team={props.team}
              user={props.user}
            />
          </>
        ) : (
          ""
        )}
        {showPaymentsArchive ? (
          <PaymentsArchive
            close={handleShowPaymentsArchive}
            paymentsArchiveSheetData={props.paymentsArchiveSheetData}
            paymentsArchiveData={props.paymentsArchiveData}
            paymentsData={paymentsClear}
            paymentsSheetData={props.paymentsSheetData}
            transactionsSheetData={props.transactionsSheetData}
            transactionsData={props.transactionsData}
            refreshData={props.refreshData}
            team={props.team}
            logClientAction={props.logClientAction}
            checkPermissions={props.checkPermissions}
            lawyersData={props.lawyersData}
            courtsData={props.courtsData}
            banksData={props.banksData}
            upData={props.user}
            users={props.users}
            userRole={props.user.role}
          />
        ) : (
          ""
        )}
        {showPaymentReport ? (
          <PaymentsReport
            close={handleShowPaymentReport}
            paymentsData={paymentsClear}
            paymentsSheetData={props.paymentsSheetData}
            transactionsSheetData={props.transactionsSheetData}
            transactionsASheetData={props.transactionsNaSheetData}
            transactionsData={props.transactionsData}
            paymentsArchiveSheetData={props.paymentsArchiveSheetData}
            id={paymentReportValue ? paymentReportValue : props.payId}
            refreshData={props.refreshData}
            place="payments"
            user={props.user.name}
            userRole={props.user.role}
            type="assigned"
            clients={props.clients}
            team={props.team}
            users={props.users}
            logClientAction={props.logClientAction}
            checkPermissions={props.checkPermissions}
            lawyersData={props.lawyersData}
            courtsData={props.courtsData}
            banksData={props.banksData}
            upData={props.user}
          />
        ) : (
          ""
        )}
        {showTransactions ? (
          <Transactions
            close={handleShowTransactions}
            transactionsSheetData={props.transactionsSheetData}
            transactionsASheetData={props.transactionsNaSheetData}
            transactionsData={props.transactionsData}
            transactionsAData={props.transactionsNaData}
            paymentsSheetData={props.paymentsSheetData}
            paymentsData={paymentsClear}
            refreshData={props.refreshData}
            user={props.user}
            type="assigned"
          />
        ) : (
          ""
        )}
        {showTransactionsNa ? (
          <Transactions
            close={handleShowTransactions}
            transactionsSheetData={props.transactionsNaSheetData}
            transactionsASheetData={props.transactionsSheetData}
            transactionsData={props.transactionsNaData}
            transactionsAData={props.transactionsData}
            paymentsSheetData={props.paymentsSheetData}
            paymentsData={paymentsClear}
            refreshData={props.refreshData}
            user={props.user}
            type="not_assigned"
          />
        ) : (
          ""
        )}
        {showAddNewTransactions ? (
          <AddNewTransactions
            close={handleShowAddNewTransactions}
            refreshData={props.refreshData}
            transactionsSheetData={props.transactionsSheetData}
            transactionsData={props.transactionsData}
            transactionsNaSheetData={props.transactionsNaSheetData}
            transactionsNaData={props.transactionsNaData}
            paymentsSheetData={props.paymentsSheetData}
            paymentsData={paymentsClear}
          />
        ) : (
          ""
        )}
        {!showPaymentsArchive &&
        !showTransactions &&
        !showTransactions &&
        !showPaymentReport &&
        !showTransactionsNa ? (
          <>
            {loading ? (
              <Loading />
            ) : (
              <div id="reportP" className="mainContainerTransactions">
                <div className="closeButtonBoxNotePopUp">
                  <div className="closeButtonBoxNotePopUp_col1">
                    Lista płatności - ilość rekordów {payments.length}
                  </div>
                </div>
                <div className="desktopFilters">{desktopFilters}</div>
                <div className="mobileFilters">{mobileFilters}</div>
                <span className="noteModuleP">
                  kliknij w rekord, aby zobaczyć szczegóły
                </span>
                <div className="contentBoxPayments">
                  <div className="desktopFilters">{paymentsData}</div>
                  <div className="mobileFilters">{paymentsDataMobile}</div>
                </div>
              </div>
            )}
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Payments;
